module.exports = __webpack_public_path__ + "static/media/Quasar.d6e5f923.png";